import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = ()=> {
    return  {
        loadingBanks: false,
        banks: []
    }
}

export default {
  namespaced: true,
  state: {
    loadingBanks: false,
    banks: []
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setBanks(state, payload) {
      state.banks = payload
    },
    setLoadingBanks(state, payload) {
      state.loadingBanks = payload
    }
  },
  actions: {
    async loadBanks(ctx) {

        ctx.commit('setLoadingBanks', true)
        const response = await ApiUtils.makeGet('payments/banks')
        ctx.commit('setLoadingBanks', false)

        if(response.ok){
          const json = await response.json()
          ctx.commit('setBanks', json.result.banks)
        }


    }
  }
}
